import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {trackEvent} from 'analytics/Analytics';
import {assertAndContinue} from 'Asserts';
import {ActionOrigin, DATA_FRAMES_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {DataFrame} from 'data-frames/DataFrameTypes';
import {DataFrameTableMode} from 'data-frames/table/DataFrameTableConstants';
import {BLUE_LIGHT, GRAY} from 'ui-library/Colors';
import Option from 'ui-library/menus/Option';

import {ToolbarActionRenderParams} from '../DataFrameActionToolbar';

/**
 * TODO(BNCH-123685): Move to analysis-tool/data-view/ module once `renderToggleChipsOption` is removed.
 */
export function getToggleChipsAction(
  analyticsData: {
    dataFrameId?: string;
    actionOrigin: ActionOrigin;
  },
  tableMode: DataFrameTableMode,
  setTableMode: (newTableMode: DataFrameTableMode) => void
): OverflowDataViewAction {
  assertAndContinue(
    tableMode === DataFrameTableMode.RICH || tableMode === DataFrameTableMode.TEXT,
    'getToggleChipsAction only supports RICH and TEXT modes',
    {tableMode}
  );

  return {
    icon: 'check',
    isToggled: tableMode === DataFrameTableMode.RICH,
    label: 'Show chips in table',
    onClick: () => {
      const newTableMode =
        tableMode === DataFrameTableMode.RICH ? DataFrameTableMode.TEXT : DataFrameTableMode.RICH;

      trackEvent(DATA_FRAMES_ANALYTICS_ACTIONS.UPDATED_DATA_FRAME_TABLE_MODE, {
        data_frame_id: analyticsData.dataFrameId,
        action_origin: analyticsData.actionOrigin,
        new_table_mode: newTableMode,
      });
      setTableMode(newTableMode);
    },
  };
}

/**
 * @deprecated TODO(BNCH-123685): Remove once uses of DataFrameTableWrapper are removed.
 */
export default function renderToggleChipsOption(
  dataFrame: DataFrame,
  params: ToolbarActionRenderParams
): JSX.Element {
  const option = getToggleChipsAction(
    {
      actionOrigin: params.actionOrigin,
      dataFrameId: params.dataFrameId,
    },
    params.tableMode,
    params.setTableMode
  );

  return (
    <Option
      icon={option.icon}
      iconClassName={css(params.tableMode === DataFrameTableMode.RICH ? styles.richIcon : styles.textIcon)}
      onSelect={option.onClick}
      key="ToggleChipsOption"
    >
      {option.label}
    </Option>
  );
}

const styles = StyleSheet.create({
  richIcon: {
    color: BLUE_LIGHT,
  },
  textIcon: {
    color: GRAY,
  },
});
